import { Injectable } from '@angular/core';
import { ApiService } from '@src/app/core/services/api/api.service';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
export interface IAStatusResponse {
  chatbot_enabled: boolean;
}
export interface ChatbotTokenResponse {
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class ChatbotService extends ApiService<any> {
   private readonly endpoints = {
    AIStatus: '/status',
  };

  constructor() {
    super();
    this.moduleUrl.set('/headless/chatbot');
  }

   getAIActivationStatus(): Observable<IAStatusResponse> {
    const url = `${this.url()}${this.endpoints.AIStatus}`;
    return this.http.get<IAStatusResponse>(url);
  }

  getChatbotAuthToken(): Observable<ChatbotTokenResponse> {
    return this.http.get<ChatbotTokenResponse>(
      environment.chatbotTokenUrl
    );
  }
}
